import itemTransformer from "@models/Item";
import orderTransformer from "@models/Order";
import quoteTransformer from "@models/Quote";
import variantTransformer from "@models/Variant";

import apiClient from "./apiClient";

const client = apiClient();

client.registerTransformer(variantTransformer);
client.registerTransformer(itemTransformer);
client.registerTransformer(orderTransformer);
client.registerTransformer(quoteTransformer);

export default client;
